export var GET_HOURS = '[Stats] Get Hours';
export var GET_HOURS_SUCCESS = '[Stats] Get Hours Success';
export var GET_HOURS_ERROR = '[Stats] Get Hours Error';
var GetHours = /** @class */ (function () {
    function GetHours(payload) {
        this.payload = payload;
        this.type = GET_HOURS;
    }
    return GetHours;
}());
export { GetHours };
var GetHoursSuccess = /** @class */ (function () {
    function GetHoursSuccess(payload) {
        this.payload = payload;
        this.type = GET_HOURS_SUCCESS;
    }
    return GetHoursSuccess;
}());
export { GetHoursSuccess };
var GetHoursError = /** @class */ (function () {
    function GetHoursError(payload) {
        this.payload = payload;
        this.type = GET_HOURS_ERROR;
    }
    return GetHoursError;
}());
export { GetHoursError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/statistics/store/actions/hours.action.ts.pre-build-optimizer.js